<template>
	<v-expansion-panels>
		<v-expansion-panel>
			<v-expansion-panel-header>
				{{ $t("Filter") }}
			</v-expansion-panel-header>
			<v-divider></v-divider>
			<v-expansion-panel-content>
				<v-layout row wrap class="py-4">
					<v-flex xs12 md3>
						<v-text-field v-model="filter.two_factor_code" type="text" :placeholder="$t('Code')" clearable hide-details></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field v-model="filter.name" type="text" :placeholder="$t('Name')" clearable hide-details></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-select v-model="filter.title" :items="genders" :placeholder="$t('Gender')" clearable type="text" hide-details></v-select>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field v-model="filter.phone" :placeholder="$t('Phone')" clearable hide-details></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field v-model="filter.email" :placeholder="$t('Email')" type="text" clearable hide-details></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field v-model="filter.address" :placeholder="$t('Address')" type="text" clearable hide-details></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-select v-model="filter.is_thalias_employee" :items="[
							{
								value: null,
								text: $t('All'),
							},
							{
								value: 1,
								text: $t('Yes'),
							},
							{
								value: 0,
								text: $t('No'),
							},
						]" :placeholder="$t('Is Thalias Bee')" clearable type="text" hide-details></v-select>
					</v-flex>
				</v-layout>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
	export default {
		props: ["value"],
		data() {
			return {
				genders: [
					{
						text: this.$t("label.male"),
						value: "male",
					},
					{
						text: this.$t("label.female"),
						value: "female",
					},
				],
			};
		},
		computed: {
			filter: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
		watch: {
			filter: {
				handler() {
					this.$emit("filter");
				},
				deep: true,
			},
		},
	};
</script>